const MODULE_NAME = 'RepairSelect';

// eslint-disable-next-line import/prefer-default-export
export const SEND_REPAIR_SELECT_REQUEST = `${MODULE_NAME}/SEND_REPAIR_SELECT_REQUEST`;
